export class RequestsCatalogCounterApi
{
    catalogId: number;
    catalogFR: string;
    catalogEN: string;
    count: number;
}
